<template>
    <base-layout>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md5>
                    <v-card class="elevation-0 pa-4">
                        <v-card-text class="text-xs-left">
                            <h3 class="mb-4 title font-weight-bold">{{ $t('resetPasswordComplete.title') }}</h3>

                            <v-form @submit.prevent="handleSubmit" novalidate>
                                <p class="font-weight-medium">{{ $t('resetPasswordComplete.description') }}</p>
                                <v-text-field
                                    v-model.trim="password"
                                    :error-messages="passwordErrors"
                                    @blur="$v.password.$touch()"
                                    name="password"
                                    :label="$t('resetPasswordComplete.password')"
                                    :disabled="submitting"
                                    type="password"
                                    placeholder=" "
                                    outline
                                />
                                <v-text-field
                                    v-model.trim="confirmPassword"
                                    :error-messages="confirmPasswordErrors"
                                    @blur="$v.confirmPassword.$touch()"
                                    name="confirmPassword"
                                    :label="$t('resetPasswordComplete.confirmPassword')"
                                    :disabled="submitting"
                                    type="password"
                                    required
                                    placeholder=" "
                                    outline
                                />

                                <v-alert
                                    :value="error"
                                    dismissible
                                    type="error"
                                    transition="scale-transition">
                                    {{ error }}
                                </v-alert>

                                <div class="mb-3 text-xs-right">
                                    <v-btn :to="{ name: 'login' }" round>
                                        {{ $t('resetPasswordComplete.cancel') }}
                                    </v-btn>
                                    <v-btn
                                        class="btn-wide"
                                        type="submit"
                                        color="tertiary"
                                        :loading="submitting"
                                        :disabled="submitting"
                                        dark
                                        round
                                    >
                                        {{ $t('resetPasswordComplete.submit') }}
                                    </v-btn>
                                </div>
                            </v-form>
                        </v-card-text>
                    </v-card>
                    <p class="font-weight-bold grey--text text--darken-1 mt-2 pa-2 text-xs-center">
                        <language-switch />
                    </p>
                </v-flex>
            </v-layout>
        </v-container>
    </base-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required, sameAs } from 'vuelidate/lib/validators';
import BaseLayout from '../components/layout/BaseLayout.vue';
import LanguageSwitch from '../components/common/LanguageSwitch.vue';

export default {
    name: 'reset-password-complete',
    components: {
        LanguageSwitch,
        BaseLayout,
    },
    validations: {
        password: { required },
        confirmPassword: {
            required,
            sameAs: sameAs('password'),
        },
    },
    props: {
        token: String,
    },
    data() {
        return {
            password: '',
            confirmPassword: '',
            error: null,
        };
    },
    computed: {
        passwordErrors() {
            const errors = [];
            if (!this.$v.password.$dirty) {
                return errors;
            }
            if (!this.$v.password.required) {
                errors.push(this.$t('validation.required'));
            }
            return errors;
        },
        confirmPasswordErrors() {
            const errors = [];
            if (!this.$v.confirmPassword.$dirty) {
                return errors;
            }
            if (!this.$v.confirmPassword.required) {
                errors.push(this.$t('validation.required'));
            }
            if (!this.$v.confirmPassword.sameAs) {
                errors.push(this.$t('validation.sameAs'));
            }
            return errors;
        },
        ...mapState({
            submitting: state => state.auth.loading.resetPasswordComplete,
        }),
    },
    methods: {
        async handleSubmit() {
            this.error = null;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.resetPasswordComplete({
                    token: this.token,
                    password: this.password,
                });
            } catch (e) {
                this.error = e.message;
            }
        },
        ...mapActions({
            resetPasswordComplete: 'auth/resetPasswordComplete',
        }),
    },
};
</script>

<style lang="scss" scoped>
</style>
